import React, { Component, useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import Header from "../../../Landingpagecomponents/Header/header";
import { Grid, Typography, Paper, LinearProgress, Tooltip, Avatar } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Slide from "react-reveal/Slide";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import YesNoQuestion from "../../../Assessment/questiontypes/yesNoQuestion";
import PictureChoice from "../../../Assessment/questiontypes/pictureChoice";
import MultipleChoice from "../../../Assessment/questiontypes/multipleChoice";
import DropDownList from "../../../Assessment/questiontypes/dropDownList";
import Question from "../../../Assessment/question";
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';
import moment from 'moment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GradeIcon from '@material-ui/icons/Grade';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';

function generate(element) {
  return [0, 1].map((value) =>
    React.cloneElement(element, {
      key: value,
    }),
  );
}

const useStyles = makeStyles((theme) => ({
  logo: {
      margin: 10,
      marginBottom: 10,
      borderRadius: 16,
      backgroundColor: 'transparent',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      justify: 'center',
      maxWidth: 500,
      minWidth: 200,
      width: '100%',
      height: 'auto',
      [theme.breakpoints.down('xl')]: {
        maxWidth: 450,
      },
      [theme.breakpoints.down('lg')]: {
        maxWidth: 390,
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: 350,
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: 300,
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: 280,
      },
    },
  h1: {
      marginTop: 5,
      marginBottom: 8,
      color: '#002D55',
      fontSize: 'clamp(18px, 1.6vw, 26px)',
    },
    title: {
    color: '#002D55',
    marginTop: '0%',
    marginLeft: 0,
    marginRight: 0,
    fontWeight: 'bold',
    fontSize: 'clamp(14px, 1.8vw, 28px)',
  },
  title2: {
    color: '#002D55',
    marginTop: '0%',
    marginLeft: 0,
    marginRight: 0,
    fontWeight: 'bold',
    fontSize: 'clamp(24px, 2vw, 32px)',
  },
  summary: {
    color: '#002D55',
    fontWeight: 'bold',
    fontSize: 'clamp(14px, 1.3vw, 20px)',
  },
  subheader: {
    color: '#002D55',
    fontWeight: 'bold',
    fontSize: 'clamp(14px, 1.15vw, 18px)',
  },
    // small circular ring inner label (used for progress ring)
    ringInner: {
      fontWeight: 800,
      color: '#002D55',
      fontSize: 'clamp(9px, 0.75vw, 12px)',
    },
  list: {
      marginBottom: 5,
      marginTop: -20,
      fontSize: 'clamp(11px, 1vw, 16px)',
      [theme.breakpoints.down('md')]: {
        marginBottom: 0,
        marginTop: -15,
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
        marginTop: -10,
      },
    },
  listIcon: {
      color: '#00e676',
      fontSize: 'clamp(16px, 1.5vw, 24px)',
      marginRight: 8,
      marginBottom: 0,
      verticalAlign: 'middle',
    },
    // chip styles used in PatientJourney for compact time chips
    chipBase: {
      fontSize: 'clamp(10px, 0.75vw, 12px)',
      marginTop: 1,
    },
    chipTime: {
      fontWeight: 'bold'
    },
    metaDate: {
      fontWeight: 'bold',
      color: '#002D55',
      fontSize: 'clamp(12px, 1vw, 16px)',
      textAlign: 'center'
    },
    metaExplainer: {
      color: '#486d86',
      marginTop: 8,
      fontSize: 'clamp(10px, 0.82vw, 13px)',
      textAlign: 'center'
    },
      // responsive root container uses available viewport height
      rootContainer: {
        textAlign: 'center',
        marginTop: 0,
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: '100%',
        // use most of the viewport height but leave room for chrome/header
        minHeight: 'calc(85vh - 160px)',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
          minHeight: 'calc(75vh - 540px)',
          padding: theme.spacing(1),
        },
        [theme.breakpoints.down('sm')]: {
          minHeight: 'calc(85vh - 220px)',
          padding: theme.spacing(1),
        }
      },
    StarIcon: {
      color: '#002D55',
      fontSize: 'clamp(24px, 2.3vw, 36px)',
      marginRight: 8,
      marginLeft: 6,
      marginBottom: 6,
      verticalAlign: 'middle',
    },
  infoButton: {
      backgroundColor: '#e3eafc',
      color: '#002D55',
      fontWeight: 600,
      fontSize: 'clamp(11px, 0.9vw, 15px)',
      margin: '4px',
      padding: '8px 24px',
      borderRadius: 8,
      boxShadow: 'none',
      textTransform: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        padding: '7px 20px',
      },
      [theme.breakpoints.down('md')]: {
        padding: '6px 16px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '5px 12px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '4px 8px',
      },
    },
    actionButton: {
      boxShadow: "none",
      textTransform: "none",
      fontSize: 'clamp(11px, 1.4vw, 22px)',
      padding: "15px 25px",
      lineHeight: 0.5,
      borderRadius: 86,
      marginTop: 10,
      marginBottom: 10,
      backgroundColor: "#002D55",
      [theme.breakpoints.down('lg')]: {
        padding: '12px 25px',
      },
      [theme.breakpoints.down('md')]: {
        padding: '10px 21px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '8px 17px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '6px 13px',
      },
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(","),
      "&:hover": {
        boxShadow: "none",
        backgroundColor: "#fb741a",
      },
      "&:active": {
        backgroundColor: "#fb741a",
        boxShadow: "none"
      },
      "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
      }
    },
    linearTrack: {
      backgroundColor: 'rgba(89, 93, 89, 0.18)',
  },
  linearBar: {
    backgroundColor: '#fb741a',
  },
}));

const ActionButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 20,
    padding: "0px 40px",
    border: "1px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:hover": {
      backgroundColor: "#0069d9",
      borderColor: "#0062cc",
      boxShadow: "none"
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#0062cc",
      borderColor: "#005cbf"
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    }
  }
})(Button);

function TreatmentSessionLandingPage(props) {
  const classes = useStyles();
  const phaseProgressDisplay = props.phaseProgressDisplay || null;
  // renderRing helper (small circular progress indicator)
  const renderRing = (color, value, size = 48, labelInside, emptyColor = 'rgba(89, 93, 89, 0.18)') => {
    const numericRaw = (value === null || value === undefined) ? NaN : Number(value);
    const valid = Number.isFinite(numericRaw);
    // make progress discrete: round to nearest 5% to reduce noise
    const numeric = valid ? Math.max(0, Math.min(100, Math.round(numericRaw / 5) * 5)) : NaN;
    const deg = Number.isFinite(numeric) ? Math.max(0, Math.min(360, numeric * 3.6)) : 0;
    const gradient = `conic-gradient(${emptyColor} 0deg ${360 - deg}deg, ${color} ${360 - deg}deg 360deg)`;

    // center content: show START button if onStart is provided, otherwise show label
    const centerContent = props.onStart ? (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
        
        <Button
          variant="contained"
          onClick={props.onStart}
          className={classes.actionButton}
          style={{ padding: 'clamp(3px, 0.4vw, 5px) clamp(6px, 0.7vw, 10px)', fontSize: 'clamp(10px, 0.9vw, 13px)', lineHeight: 1 }}
        >
           <h2 style={{ margin: 0, fontSize: 'clamp(0.7rem, 0.9vw, 1rem)' }}>START</h2>
        </Button>
      </div>
    ) : (
      <div className={classes.ringInner}>{(labelInside !== undefined && labelInside !== null) ? labelInside : (valid ? `${Math.round(numericRaw)}` : '--')}</div>
    );

    return (
      <Box style={{
        width: size,
        height: size,
        borderRadius: '50%',
        padding: 6,
        background: 'rgba(255,255,255,0.95)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Box style={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: gradient
        }}>
          <Box style={{
            width: '69%',
            height: '69%',
            borderRadius: '50%',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {centerContent}
          </Box>
        </Box>
      </Box>
    );
  };
  // phase/summary defaults (safe fallbacks if props not provided)
  const phaseLabel = props.phaseLabel || 'Current Phase';
  const phasePercent = (typeof props.phasePercent === 'number') ? props.phasePercent : (typeof props.progress === 'number' ? Math.round(props.progress) : 0);
  const phaseAnchorSummary = phaseProgressDisplay && phaseProgressDisplay.anchor_summary
    ? phaseProgressDisplay.anchor_summary
    : (phasePercent !== null && phasePercent !== undefined ? `${phasePercent}% complete` : '');
  const phaseProgressTooltip = phaseProgressDisplay ? (
    <div style={{ lineHeight: 1.35 }}>
      <div><strong>{props.title || phaseLabel}</strong></div>
      {phaseAnchorSummary ? <div>{phaseAnchorSummary}</div> : null}
      {Array.isArray(phaseProgressDisplay.conditions) && phaseProgressDisplay.conditions.length ? (
        phaseProgressDisplay.conditions.map((condition, index) => (
          <div key={`${condition.metric_key || 'condition'}-${index}`}>
            {`${condition.label || condition.metric_key}: ${condition.summary || `${condition.actual_display || '-'} / ${condition.threshold_display || '-'}`} ${condition.passed ? 'passed' : 'pending'}`}
          </div>
        ))
      ) : null}
      {Array.isArray(phaseProgressDisplay.blocking_reasons) && phaseProgressDisplay.blocking_reasons.length ? (
        <div style={{ marginTop: 6 }}><strong>{`Waiting on: ${phaseProgressDisplay.blocking_reasons.join('; ')}`}</strong></div>
      ) : null}
    </div>
  ) : `Progress: ${phasePercent || 0}%`;
  const nextThreshold = (typeof props.nextThreshold === 'number') ? props.nextThreshold : 80;
  const level = props.level || { color: '#fb741a', name: 'Level 1' };
  // Compliance: prefer props, otherwise compute from completedSessionsList + planned sessions/day
  const plannedFromProps = (props && (props.planned_sessions_per_day_overall ?? props.plannedSessionsPerDay ?? props.plannedSessionsPerDayOverall)) || null;
  // prefer API-provided allowedSessions, then explicit planned props, otherwise default to 3
  const plannedPerDay = (Number.isFinite(Number(props.allowedSessions)) && Number(props.allowedSessions) > 0)
    ? Number(props.allowedSessions)
    : (Number.isFinite(Number(plannedFromProps)) && Number(plannedFromProps) > 0)
      ? Number(plannedFromProps)
      : 1;

  const computeCompliance = (completedSessionsList, planned) => {
    if (!Array.isArray(completedSessionsList) || completedSessionsList.length === 0) return { overallPercent: 0, last7Percent: 0, sessionsToday: 0, allowedSessions: planned };
    const counts = {};
    let minDate = null; let maxDate = null;
    completedSessionsList.forEach(s => { if (s && s.completed_date) { const d = new Date(s.completed_date); if (isNaN(d)) return; const k = d.toISOString().slice(0,10); counts[k] = (counts[k]||0)+1; if (!minDate || d < minDate) minDate = d; if (!maxDate || d > maxDate) maxDate = d; } });
    if (!minDate || !maxDate) return { overallPercent: 0, last7Percent: 0, sessionsToday: 0, allowedSessions: planned };
    const totalDays = Math.max(1, Math.floor((maxDate - minDate) / (1000*60*60*24)) + 1);
    const totalCompleted = Object.values(counts).reduce((a,b)=>a+b,0);
    const overallPercent = Math.min(100, Math.round((totalCompleted / (totalDays * planned)) * 100));
    const today = new Date(); let last7Completed = 0; for (let i=0;i<7;i++){ const d=new Date(today); d.setDate(today.getDate()-i); const k=d.toISOString().slice(0,10); last7Completed += counts[k]||0; }
    const last7Percent = Math.min(100, Math.round((last7Completed / (7 * planned)) * 100));
    const todayKey = new Date().toISOString().slice(0,10);
    const sessionsToday = counts[todayKey] || 0;
    return { overallPercent, last7Percent, sessionsToday, allowedSessions: planned };
  };

  const compliance = computeCompliance(props.completedSessionsList || [], plannedPerDay);
  const avgCompliance = (typeof props.avgCompliance === 'number') ? props.avgCompliance : compliance.overallPercent;
  const avgAdherenceLast7 = (typeof props.avgAdherenceLast7 === 'number') ? props.avgAdherenceLast7 : compliance.last7Percent;
  const sessionsTodayDisplay = (typeof props.sessionsToday === 'number') ? props.sessionsToday : compliance.sessionsToday;
  const allowedSessionsDisplay = (typeof props.allowedSessions === 'number') ? props.allowedSessions : compliance.allowedSessions;
  const pctDisplay = Math.round((sessionsTodayDisplay / Math.max(1, allowedSessionsDisplay)) * 100);
  return (
    <div className={classes.rootContainer}>
      <Typography className={classes.title2} variant="h1" style={{ marginBottom: 8 }}>
       Ready for todays program?
      </Typography>
      {/* Phase summary panel (small progress bar + level info) centered and split into two columns */}
      <Paper elevation={1} style={{ width: '100%', maxWidth: 'clamp(340px, 35vw, 470px)', padding: 'clamp(8px, 0.6vw, 10px)', borderRadius: 14, background: '#FFFFFF', marginLeft: 'auto', marginRight: 'auto', marginBottom: 'clamp(6px, 0.7vw, 10px)', textAlign: 'left' }}>
      <div style={{width: '100%', maxWidth: 'clamp(340px, 35vw, 470px)', display: 'flex', gap: 'clamp(10px, 1.1vw, 16px)', paddingTop: 4, justifyContent: 'center', alignItems: 'flex-start', marginBottom: 'clamp(5px, 0.6vw, 8px)', marginLeft: 'auto', marginRight: 'auto' }}>
        {/* left meta column */}
        <div style={{  background: 'transparent', padding: 'clamp(8px, 0.9vw, 12px)', borderRadius: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #dce0e4ff' }}>
          {/*<div className={classes.metaDate}>{moment().format('MMM D, YYYY')}</div>*/}
          <div className={classes.subheader} style={{ textAlign: 'center' }}>
            You completed <b>{sessionsTodayDisplay}/{allowedSessionsDisplay}</b> recommended sessions today!  
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 6, alignItems: 'center' }}>
            {/*{props.completedSessionsList && props.completedSessionsList.length > 0 ? (
              props.completedSessionsList.map((s, i) => (
                <Chip key={s.id || i} className={clsx(classes.chipBase, classes.chipTime)} label={s.completed_date ? moment(s.completed_date).format('- HH:mm') : '—'} size="small" style={{ background: '#fff', color: '#002D55' }} />
              ))
            ) : null}*/}
            {renderRing('#fb741a', pctDisplay, Math.round(Math.min(180, Math.max(120, window.innerWidth * 0.13))), `${sessionsTodayDisplay}/${allowedSessionsDisplay}`)}
      
          </div>
        </div>

      </div>
        <Grid container spacing={0} display='flex' justifyContent="space-between" alignItems="center" style={{ marginLeft: 'auto', marginRight: 'auto', display: 'inline-flex', flexWrap: 'nowrap', width: '92%'}}>
          <Grid item xs={5} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Tooltip title={`Next level - reach compliance of ${nextThreshold}%`} arrow>
              <Avatar style={{ background: level.color, width: 'clamp(32px, 3.2vw, 44px)', height: 'clamp(32px, 3.2vw, 44px)' }}>
                <EmojiEventsIcon style={{ color: '#fff', fontSize: 'clamp(15px, 1.4vw, 20px)' }} />
              </Avatar>
            </Tooltip>
            <Typography style={{ fontSize: 'clamp(10px, 0.82vw, 12px)', color: '#486d86', marginTop: 'clamp(4px, 0.4vw, 6px)', fontWeight: 700 }}>{level.name}</Typography>
          </Grid>

          <Grid item xs={8} width="100%">
            <Tooltip title={phaseProgressTooltip} arrow interactive>
              <div>
                <Typography className={classes.subheader} style={{ marginTop: '1%', marginLeft: 0, marginRight: 0 }} variant="h5">
                  {props.title}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={phasePercent || 0}
                  classes={{ colorPrimary: classes.linearTrack, barColorPrimary: classes.linearBar }}
                  style={{ marginBottom: 8, height: 8, borderRadius: 6 }}
                />
              </div>
            </Tooltip>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '95%' }}>
              <Box>
                <Typography style={{ fontSize: 'clamp(9px, 0.72vw, 11px)', fontWeight: 700, color: '#002D55' }}>Adherence:</Typography>
              </Box>
              <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end',  }}>
                <Typography style={{ fontSize: 'clamp(9px, 0.72vw, 11px)', color: '#486d86', alignSelf: 'flex-end' }}>
                  7d: <strong>{avgAdherenceLast7}%</strong> | Overall: <strong>{avgCompliance}%</strong>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      {/*<Grid container style={{ justifyContent: "center" }}>
          <Grid item mt={1} style={{ marginLeft: 7, width: "70%", marginTop: 0, marginBottom: 18, maxWidth: 350, minWidth: 180, justify: "center" }}>
            <Typography className={classes.subheader} style={{ marginTop: "1%", marginLeft: 15, marginRight: 0 }} variant="h5">
              {props.title}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={props.progress}
              classes={{ colorPrimary: classes.linearTrack, barColorPrimary: classes.linearBar }}
              style={{ marginBottom: 8, height: 8, borderRadius: 6 }}
            />
          </Grid>
        </Grid>*/}

      <Paper elevation={1} style={{ width: '100%', maxWidth: 'clamp(340px, 35vw, 470px)', background: '#FFFFFF', padding: 'clamp(5px, 0.6vw, 8px)', borderRadius: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #e8eef6', marginLeft: 'auto', marginRight: 'auto', marginTop: 'clamp(4px, 0.4vw, 6px)' }}>
        <Typography className={classes.subheader} variant="h6" style={{ marginTop: 0, marginBottom: 5 }}>
          Next session planned for today:
        </Typography>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            disabled
            className={classes.infoButton}
            style={{
              backgroundColor: "#e3eafc",
              color: "#002D55",
              fontWeight: 600,
              borderRadius: 8,
              boxShadow: "none",
              textTransform: "none",
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            {props.exercisesPlanned} exercises
            {/*<ListAltIcon className={classes.listIcon} style={{ color: "#002D55", marginLeft: 10, verticalAlign: "middle" }} />*/}
          </Button>

          {props.equipmentList && props.equipmentList.length > 0 ? (
            props.equipmentList.map((item, idx) => (
              <Button
                key={idx}
                variant="contained"
                disabled
                className={classes.infoButton}
                style={{ margin: 6, textTransform: 'none' }}
              >
                {item}
              </Button>
            ))
          ) : (
            <Button variant="contained" disabled className={classes.infoButton} style={{ margin: 6, textTransform: 'none' }}>
              No special equipment needed
            </Button>
          )}
        </div>
      </Paper>
      {/*<Typography style={{ color: "#002D55", marginTop: 0, marginBottom: 15, fontWeight: "bold" }} variant="h6">
        Click "Start" below to continue your progress!
      </Typography>*/}
      
    </div>
  );
}

export default TreatmentSessionLandingPage;
